module.exports = __webpack_public_path__ + "img/bg.0465c2f4.svg";